import _objectSpread from "C:/Users/Fanni/OneDrive/Asztali g\xE9p/brandfashion/EmptyYS-2020/vue/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// Helpers
import { mapState } from 'vuex';
export default {
  props: {
    value: {
      type: Number,
      required: true
    },
    initialLimit: {
      type: Number,
      default: 99
    },
    stockTracking: {
      type: Boolean,
      default: false
    },
    stockPurchasable: {
      type: Boolean,
      default: false
    },
    stockLevel: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      limit: 99
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(['cartIsUpdating'])), {}, {
    stockAvailable: function stockAvailable() {
      return !this.stockTracking || this.stockPurchasable || this.stockTracking && this.stockLevel > 0;
    }
  }),
  watch: {
    stockLevel: function stockLevel() {
      this.setLimit();
    }
  },
  created: function created() {
    this.limit = this.initialLimit;
    this.setLimit();
  },
  methods: {
    // Set limit depending on variant
    setLimit: function setLimit() {
      if (!this.stockTracking || this.stockPurchasable) return;
      this.limit = this.stockLevel;
      var newValue = this.value > this.limit ? this.limit : this.value;
      this.setQuantity(newValue);
    },
    // Increment quantity
    incrementQuantity: function incrementQuantity() {
      var newQuantity = this.value + 1;
      this.setQuantity(newQuantity);
    },
    // Decrement quantity
    decrementQuantity: function decrementQuantity() {
      var newQuantity = this.value - 1;
      this.setQuantity(newQuantity);
    },
    setQuantity: function setQuantity(newQuantity) {
      if (isNaN(newQuantity) || +newQuantity <= 0 || !newQuantity) {
        this.$emit('input', 1);
      } else {
        var quantity = Math.min(newQuantity % 1 !== 0 ? Math.round(newQuantity) : newQuantity, this.limit);
        this.$emit('input', quantity);
      }
    }
  }
};